<template>
  <a
    :href="notification.link || '#'"
    class="block hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 bg-white cursor-pointer"
    :class="[
      compact ? 'p-3' : 'px-8 h-[76px] flex items-center gap-4'
    ]"
    @click="handleClick"
  >
    <div
      v-if="compact"
      class="flex gap-3 items-start"
    >
      <div
        v-if="!notification.read"
        class="w-2 h-2 rounded-full mt-1.5 shrink-0 bg-blue-500"
      />
      <div
        class="flex-1 min-w-0 pr-2"
        :class="{ 'pl-3.5': notification.read }"
      >
        <div class="flex items-start justify-between gap-2 mb-0.5">
          <p class="font-['Inter',sans-serif] text-[13px] text-gray-900 truncate font-medium">
            {{ notification.title }}
          </p>
          <span class="shrink-0 text-[11px] text-gray-400 font-medium whitespace-nowrap">{{ formattedTime }}</span>
        </div>
        <p class="text-[12px] text-gray-500 leading-tight line-clamp-1">{{ notification.body }}</p>
      </div>
    </div>
    <template v-else>
      <div
        v-if="!notification.read"
        class="w-3 h-3 rounded-full shrink-0 bg-blue-500"
      />
      <div
        class="flex-1 min-w-0 flex flex-col gap-1"
        :class="{ 'pl-7': notification.read }"
      >
        <p
          class="font-['Inter',sans-serif] text-[14px] truncate"
          :class="!notification.read ? 'text-gray-900 font-semibold' : 'text-gray-700 font-medium'"
        >
          {{ notification.title }}
        </p>
        <p class="font-['Inter',sans-serif] text-[12px] text-gray-400 truncate">{{ notification.body }}</p>
      </div>
      <span class="shrink-0 font-['Inter',sans-serif] text-[12px] text-gray-400 whitespace-nowrap">{{ formattedTime }}</span>
    </template>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import { useNotifications } from '../../composables/useNotifications'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  },
  compact: {
    type: Boolean,
    default: true
  }
})

const { markRead } = useNotifications()

const handleClick = () => {
  markRead(props.notification)
}

const formattedTime = computed(() => {
  if (!props.notification.timestamp) return ''
  const date = new Date(props.notification.timestamp)
  if (isNaN(date.getTime())) return ''

  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / 60000)

  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m`

  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h`

  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d`

  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
})
</script>
